import React, {ChangeEvent} from "react";
import {Input, message} from "antd";
import "../DynamicForm.scss";
import {TextElementProps} from "@data-force/app";
import {connect} from "react-redux";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = TextElementProps & DispatchProps;

class TextElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.inputChangeHandler = this.inputChangeHandler.bind(this);
    }

    inputChangeHandler({target: {value}}: ChangeEvent<HTMLInputElement>): void {
        const {
            fieldName, index, refElements, onSave,
        }: TextElementProps = this.props;
        this.props.onChange({
            fieldName, value, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    render() {
        const {
            value, className = "", readOnly,
        }: TextElementProps = this.props;

        return (
            <Input
                className={className}
                value={value}
                onChange={this.inputChangeHandler}
                disabled={readOnly}
            />
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(TextElement);
